export const fleetData = [
    {
        id: 1,
        car_name: "KIA RIO",
        gearbox: "Автомат",
        year: "2021 г.",
        img: "/icons/image53.svg"
    },
    {
        id: 2,
        car_name: "SKODA OKTAVIA",
        gearbox: "Механика",
        year: "2020 г.",
        img: "/icons/skoda.svg"
    },
    {
        id: 3,
        car_name: "LADA VESTA",
        gearbox: "Автомат",
        year: "2018 г.",
        img: "/icons/lada.svg"
    },
    {
        id: 4,
        car_name: "LADA VESTA",
        gearbox: "Механика",
        year: "2019 г.",
        img: "/icons/lada.svg"
    },
    {
        id: 5,
        car_name: "HYUNDAI CRETA",
        gearbox: "Автомат",
        year: "2021 г.",
        img: "/icons/creta.svg"
    },
    {
        id: 6,
        car_name: "HYUNDAI SOLARIS",
        gearbox: "Механика",
        year: "2020 г.",
        img: "/icons/solaris.svg"
    },
]